/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Mariano Lopez China Santiago <s_lopezchinam@globalhitss.com>, December 2020
 */
import React from 'react';
import cls from '../utils/classnames';
import './_styles.scss';
import {
    PLAN_SELECTOR,
    PLAN_SELECTOR_ITEM,
    PLAN_SELECTOR_ITEM_CARD,
    PLAN_SELECTOR_ITEM_MORE_INFO,
    PLAN_SELECTOR_ITEM_MORE_INFO_TAB,
    PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE,
    PLAN_SELECTOR_ITEM_MORE_INFO_TAB_DEACTIVATE,
    PLAN_SELECTOR_ITEM_CARD_CONTENT,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PROVIDER_LOGO,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_FREQUENCY,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PERIODICITY,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_TAX,
    PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD,
} from '../utils/classes';
import { autobind } from 'packages/core/lib';
import { ColoredButton } from '../ColoredButton';
import { Tab } from '../Keyboard/Tab';
import { Button } from '../Button';
import Device from 'src/devices/device';
import Translator from 'src/requests/apa/Translator';
import Utils, { shouldMetadataInfoShowed, setInitialFocus } from 'src/utils/Utils';
import {ITransactionLabelInfo} from 'src/payments/Interface/interface';
import { scrollIsElementVisible } from 'src/utils/Utils';
import {
    BUTTON_CONTRATA,
    BUTTON_INCLUDES,
    LABEL_PROMOTION,
    LABEL_TASK,
    LABEL_PERIODICITY,
    LABEL_PRICE
} from './constants';
import Spinner from 'src/components/Spinner';

export interface IPlanSelectorProps {
    /**
     * Array of plans
     */
    plans: IPlanSelectorItemProps[];
    /**
     * to add classname to main wrapper
     */
    className?: string;
    /**
     * callaback to fire when blue button is pressed
     */
    onBlueButton?: (activePlan: string)=> void;
}

export interface IPlanSelectorState {
    activePlan: string;
    imageBack: any;
    fallbackImage: string;
    isLoading: boolean;
}

export class PlanSelector extends React.PureComponent<IPlanSelectorProps, IPlanSelectorState> {

    private keys: any;
    private navDirection: any;
    private nextAddonIsVisible: any;
    private planSelectorScrollLeftBeforeFocus: any;

    constructor(props: IPlanSelectorProps) {
        super(props);
        this.state = {
            activePlan: '',
            imageBack: '',
            fallbackImage: '',
            isLoading: true
        };
        this.keys = Device.getDevice() && Device.getDevice().getKeys() || null;
        this.navDirection = null;
        this.nextAddonIsVisible = true;
        this.planSelectorScrollLeftBeforeFocus = 0;
    }

    @autobind
    public handleFocus(planId: string): void {
        const el = document.getElementById(planId);
        let elementForAddClass : any;

        if (el && typeof el.scrollIntoView === 'function') {
            console.log('NAV DIRECTION: ', this.navDirection);
            planId && this.moveScroll(planId);
        }

        this.setState({ activePlan: planId });
    }

    @autobind
    public moveScroll(planId: string) {
        if(!this.nextAddonIsVisible) {
            const planSelectorContainer = document.getElementById('AAFPL');
            const addonCard = document.getElementById(`planSelectorItem${planId}`);

            if(addonCard && planSelectorContainer) {
                // Ancho del contenedor
                const addonCardStyle = addonCard.currentStyle || window.getComputedStyle(addonCard);
                let addonCardWidth = 204;

                let width = 0;
                let _marginLeft = 0;
                let _marginRight = 0;
                let _paddingLeft = 0;
                let _paddingRight = 0;
                let _borderLeft = 0;
                let _borderRight = 0;

                let margin = 0;
                let padding = 0;
                let border = 0;

                if(Utils.isNotNullOrNotUndefined(addonCardStyle)) {
                    if(Utils.isNotNullOrNotUndefined(addonCard.offsetWidth)) {
                        width = addonCard.offsetWidth;
                    }
                    else {
                        width = addonCard.width;
                    }

                    width = width + '';
                    width = width.replace('px', '');

                    _marginLeft = addonCardStyle.marginLeft;
                    if(Utils.isNullOrUndefined(_marginLeft)) {
                        _marginLeft = 0;
                    }
                    else {
                        _marginLeft = _marginLeft + '';
                        _marginLeft = _marginLeft.replace('px', '');
                    }

                    _marginRight= addonCardStyle.marginRight;
                    if(Utils.isNullOrUndefined(_marginRight)) {
                        _marginRight = 0;
                    }
                    else {
                        _marginRight = _marginRight + '';
                        _marginRight = _marginRight.replace('px', '');
                    }

                    margin = parseFloat(_marginLeft) + parseFloat(_marginRight);

                    _paddingLeft = addonCardStyle.paddingLeft;
                    if(Utils.isNullOrUndefined(_paddingLeft)) {
                        _paddingLeft = 0;
                    }
                    else {
                        _paddingLeft = _paddingLeft + '';
                        _paddingLeft = _paddingLeft.replace('px', '');
                    }

                    _paddingRight= addonCardStyle.paddingRight;

                    if(Utils.isNullOrUndefined(_paddingRight) || isNaN(_paddingRight)) {
                        _paddingRight = 0;
                    }
                    else {
                        _paddingRight = _paddingRight + '';
                        _paddingRight = _paddingRight.replace('px', '');
                    }

                    padding = parseFloat(_paddingLeft) + parseFloat(_paddingRight);

                     _borderLeft = addonCardStyle.borderLeftWidth;
                    if(Utils.isNullOrUndefined(_borderLeft)) {
                        _borderLeft = 0;
                    }
                    else {
                        _borderLeft = _borderLeft + '';
                        _borderLeft = _borderLeft.replace('px', '');
                    }

                    _borderRight= addonCardStyle.borderRightWidth;
                    if(Utils.isNullOrUndefined(_borderRight)) {
                        _borderRight = 0;
                    }
                    else {
                        _borderRight = _borderRight + '';
                        _borderRight = _borderRight.replace('px', '');
                    }

                    border = parseFloat(_borderLeft) + parseFloat(_borderRight);
                    addonCardWidth = parseFloat(width) + parseFloat(margin) + parseFloat(padding) + parseFloat(border);
                }

                if(isNaN(addonCardWidth) || addonCardWidth <= 0) {
                    addonCardWidth = 204;
                }
                switch(this.navDirection) {
                    default:
                        break;
                    case 'right':
                        planSelectorContainer.scrollLeft = this.planSelectorScrollLeftBeforeFocus + addonCardWidth;
                    break;
                    case 'left':
                        planSelectorContainer.scrollLeft = this.planSelectorScrollLeftBeforeFocus - addonCardWidth;
                    break;
                }
            }
        }
    }

    @autobind
    public onWillFocus(params: any) {
        console.log('PLSC Direction', params.detail.direction, 'id', params.target.id);
        if(params.target.id) {
            this.nextAddonIsVisible = scrollIsElementVisible('AAFPL', `planSelectorItem${params.target.id}`);
            this.navDirection = params.detail.direction;
            const planSelectorContainer = document.getElementById('AAFPL');
            // Scroll Inicial antes del focus
            if(planSelectorContainer) this.planSelectorScrollLeftBeforeFocus = planSelectorContainer?.scrollLeft;
        }
    }

    @autobind
    private onKeyPress(e: any): void {
        const { onBlueButton  = () => {}, plans } = this.props;
        const { activePlan } = this.state;
        const plan = plans.find(_plan => _plan.id === activePlan);
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch(currentKey){
            case "BLUE":
                activePlan &&
                    onBlueButton(activePlan);
                break;
            default:
        }
    }

    public componentWillUnmount(): void {
        document.removeEventListener("keydown", this.onKeyPress);
        document.removeEventListener("sn:willfocus", this.onWillFocus);
    }

    public async componentDidMount() {
        let { plans } = this.props;
        const { fallbackImage } = this.state;
        let validPlanImage = fallbackImage;
        let dataNew = {};
        const validateImagePromises = plans.map(plan => validateImage(plan.backgroundImage));
        const isValidArray = await Promise.all(validateImagePromises);

        //* Validar si la imagen es valida
        const planImages = isValidArray.map((plan, index) => {
            const planes = plans.map(plan => plan.backgroundImage);
            const imageDefault = plans.map(plan => plan.fallbackImage);
            let backgroundImage = planes[index];

            validPlanImage = imageDefault[index];

            dataNew = {
                backgroundImage
            };

            if (!plan) {
                dataNew = {
                    backgroundImage: validPlanImage
                };
            }

            return dataNew;
        });

        //* Validar si la imagen es valida
        const backgrounds = planImages.filter((plan: any) => plan !== undefined);
        const mapBackgrounds = backgrounds.map((plan: any) => plan.backgroundImage);

        this.setState({ imageBack: mapBackgrounds, isLoading: false });

        if (plans.length > 0) {
            setInitialFocus(`.itemPlanSelector0`, true);
        }

        document.removeEventListener("keydown", this.onKeyPress);
        document.addEventListener("keydown", this.onKeyPress);

        document.removeEventListener("sn:willfocus", this.onWillFocus);
        document.addEventListener("sn:willfocus", this.onWillFocus);
    }

    public render(): JSX.Element {
        const { plans, className } = this.props;
        const { activePlan, imageBack, isLoading, fallbackImage } = this.state;
        const classNames = cls(PLAN_SELECTOR, className );

        return (
            <div className={classNames} id="AAFPL">
                {
                    plans.map(({id, provider, backgroundImage, providerLogo, providerLogoPlanSelector, buttonTextColorHex, buttonBGColorHex, cardColorRGB, frequency, onPlanClick, buttonText, isButtonVisible,
                        planSelectorPrice, planSelectorTax, planSelectorBonus
                    }, index) => {
                        //const newId = `plan-selector-${provider}`;
                        return (
                            <PlanSelectorItem
                                onPlanClick={onPlanClick}
                                onPlanBlur={()=>this.handleFocus('')}
                                showMoreInfoButton={ activePlan === id}
                                id={id}
                                onPlanFocus={()=>{this.handleFocus(id)}}
                                key={id}
                                provider = {provider}
                                backgroundImage={backgroundImage}
                                buttonTextColorHex={buttonTextColorHex}
                                buttonBGColorHex={buttonBGColorHex}
                                cardColorRGB={cardColorRGB}
                                providerLogo = {providerLogo}
                                providerLogoPlanSelector={providerLogoPlanSelector}
                                frequency = {frequency}
                                buttonText = {buttonText}
                                isButtonVisible = {isButtonVisible}
                                planSelectorPrice = {planSelectorPrice}
                                planSelectorTax = {planSelectorTax}
                                planSelectorBonus = {planSelectorBonus}
                                classFocusItem={index}
                                imageBack={imageBack[index]}
                                isLoading={isLoading}
                                fallbackImage={fallbackImage}
                            />
                        )
                    })
                }
            </div>
        );
    }
};

export interface ICardColor {
    r: number,
    g: number,
    b: number
}

export interface IPlanSelectorItemProps {
    id: string;
    provider: string;
    buttonBGColorHex?: string;
    buttonTextColorHex?: string;
    buttonText: string;
    cardColorRGB?: ICardColor,
    backgroundImage: string;
    providerLogo?: string;
    providerLogoPlanSelector?: string; 
    /**
     * to add classname to main wrapper
     */
    className?: string;
    frequency: string;
    onPlanClick?: React.EventHandler<any>
    onPlanFocus?: React.EventHandler<any>;
    onPlanBlur?: React.EventHandler<any>;
    showMoreInfoButton?: boolean;
    isButtonVisible: boolean,
    planSelectorPrice :ITransactionLabelInfo,
    planSelectorTax :ITransactionLabelInfo,
    planSelectorBonus :ITransactionLabelInfo,
    classFocusItem: number,
    imageBack: string,
    isLoading: boolean,
    fallbackImage: any
}

const getPlanSelectorItemStyle = (price: string, bonus: string): object => {
    if (price === '' && bonus.length > 40) {
        return {
            marginTop: '0px'
        }
    }
    else {
        return {
            marginTop: '1px',
            paddingLeft: '12px',
            paddingRight: '12px'
        }
    }
}

const getPlanSelectorCharacterStyleByPromotion = (labelPromotion: string): object => {
    if (labelPromotion.length > 25 && labelPromotion.length <= 54) {
        return {
            fontSize: '14px'
        }
    }
    return {
        fontSize : '16px'
    }
}

const getPlanSelectorCharacterStyleByButtonInludes = (labelButtonIncludes: string): object => {
    if (labelButtonIncludes.length > 25 && labelButtonIncludes.length <= 52) {
        return {
            fontSize: '14px',
            marginLeft: '4px'
        }
    }
    return {
        fontSize : '20px',
        marginLeft: '4px'
    }
}

//* Validar si la imagen es una URL
const validateImage = async (url: string) => {
    const regexp = /^(http|https):\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;
    let imgValid = false;

    //* Validar si es una URL
    if (regexp.test(url)) {
        try {
            const res = await fetch(url);
            if (res.status === 404) {
              imgValid = false;
            } else {
              imgValid = true;
            }
          } catch (err) {
            imgValid = false;
        }
    } else {
        imgValid = false;
        return false;
    }

    return imgValid;
}

export const PlanSelectorItem: React.StatelessComponent<IPlanSelectorItemProps> = ({
    id,
    backgroundImage,
    provider,
    providerLogo,
    providerLogoPlanSelector,
    buttonBGColorHex = '#000',
    buttonTextColorHex = '#FFF',
    cardColorRGB: { r = 0, g = 0 , b = 0 } = {},
    className,
    onPlanClick = ()=>{},
    onPlanFocus,
    onPlanBlur,
    showMoreInfoButton,
    buttonText,
    isButtonVisible,
    planSelectorPrice,
    planSelectorTax,
    planSelectorBonus,
    classFocusItem,
    imageBack,
    isLoading,
    fallbackImage
}) => {

    const metadataInfoPrice: any = {};
    const metadataInfoTax: any = {};
    const metadataInfoBonus: any = {};

    if (shouldMetadataInfoShowed()){
        metadataInfoPrice['data-metadata-key'] = planSelectorPrice.key;
        metadataInfoTax['data-metadata-key'] = planSelectorTax.key;
        metadataInfoBonus['data-metadata-key'] = planSelectorBonus.key;
    }

    // BUTTON CONTRATA
    const labelButtonSubscription = Utils.limitCharacters(`${buttonText}`, BUTTON_CONTRATA);
    // BUTTON INCLUDES
    const labelButtonIncludesShortText = Utils.limitCharacters(`${Translator.get('planSelector_access_option_button_subscription', '¿QUÉ INCLUYE?')}`, BUTTON_INCLUDES);
    // LABEL PROMOTION
    const labelPromotionShortText = Utils.limitCharacters(`${planSelectorBonus.label}`, LABEL_PROMOTION);
    // LABEL TASK
    const labelTask = Utils.limitCharacters(`${planSelectorTax.labelTax}`, LABEL_TASK);
    // LABEL PERIODICITY
    const labelPeriodicity = Utils.limitCharacters(`${planSelectorTax.labelPeriodicity}`, LABEL_PERIODICITY);
    // LABEL PRICE
    const labelPrice = Utils.limitCharacters(`${planSelectorPrice.label }`, LABEL_PRICE);

    if (isLoading) {
        return <Spinner className='payment' loadingMessage="" />;
    }

    return (
        <div
            id={`planSelectorItem${id}`}
            className={cls(PLAN_SELECTOR_ITEM, className)}
            onFocus={onPlanFocus}
            onBlur={onPlanBlur}
            onClick={()=>{onPlanClick(id)}}
        >
            { backgroundImage && (
                <a
                    href="javascript:void(0)"
                    className={cls(PLAN_SELECTOR_ITEM_CARD, 'focusable', `itemPlanSelector${classFocusItem}`)}
                    style={{backgroundImage: `url("${imageBack || fallbackImage}")`}}
                    id={id}
                >
                    <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT}>
                        <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT_PROVIDER_LOGO} style={{
                            textAlign: 'center'
                        }}>
                            {providerLogoPlanSelector && <img src={providerLogoPlanSelector} alt={`${provider} logo`}/>}
                        </div>
                        <div
                            className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION}
                        >
                            <div className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE_FREQUENCY}>
                                {
                                    <span {...metadataInfoPrice} className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PRICE}>
                                        { labelPrice }
                                    </span>
                                }
                                {
                                    <span className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_PERIODICITY}>
                                        {
                                            planSelectorPrice.label ? labelPeriodicity : ""
                                        }
                                    </span>
                                }
                                {
                                    <span {...metadataInfoTax} className={PLAN_SELECTOR_ITEM_CARD_CONTENT_DESCRIPTION_TAX}>
                                        {
                                            planSelectorPrice.label ? labelTask : ""
                                        }
                                    </span>
                                }
                            </div>
                            <div
                                className={`${PLAN_SELECTOR_ITEM_CARD_CONTENT_PERIOD} ${labelPromotionShortText.length > 40 ? '-text-overflow' : ''}`}
                                style={getPlanSelectorCharacterStyleByPromotion(labelPromotionShortText)}
                            >
                                <span {...metadataInfoBonus}>
                                    {`${labelPromotionShortText}`}
                                </span>
                            </div>
                            {
                                isButtonVisible &&
                                    <div style={getPlanSelectorItemStyle(planSelectorPrice.label, planSelectorBonus.label)}>
                                        <Button
                                            style={{
                                                backgroundColor: buttonBGColorHex,
                                                color: buttonTextColorHex
                                            }}
                                            type="button"
                                        >
                                            {`${labelButtonSubscription}`}
                                        </Button>
                                    </div>
                            }
                        </div>
                    </div>
                </a>
            )}
            
            <div className={PLAN_SELECTOR_ITEM_MORE_INFO}>
                <Tab className={cls(PLAN_SELECTOR_ITEM_MORE_INFO_TAB, {
                    [PLAN_SELECTOR_ITEM_MORE_INFO_TAB_ACTIVE]: !!showMoreInfoButton,
                    [PLAN_SELECTOR_ITEM_MORE_INFO_TAB_DEACTIVATE]: !showMoreInfoButton
                })}>
                    <div className='container-button-include'>
                        <ColoredButton
                            color="blue"
                            classSizeHotkey="large"
                            className={'access_option_button_blue'}
                            style={getPlanSelectorCharacterStyleByButtonInludes(labelButtonIncludesShortText)}
                        >
                            <div className='button-include'>
                                {`${labelButtonIncludesShortText}`}
                            </div>
                        </ColoredButton>
                    </div>
                </Tab>
            </div>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/packages/components/lib/PlanSelector/index.tsx